// extracted by mini-css-extract-plugin
export default {"root":"DataSetsItemButtons_root__31GKD","tooltip":"DataSetsItemButtons_tooltip__oSK79"};